var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-box"},[_c('el-row',{staticClass:"score-row-bg",attrs:{"type":"flex"}},[_c('el-col',{attrs:{"span":12}},[_c('div',[_vm._v("试卷名称："+_vm._s(_vm.form.spaperName))])]),_c('el-col',{attrs:{"span":12}},[_c('div',[_vm._v("考试类型：课程考试")])])],1),_c('QueryList',{ref:"query"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }